class Timer {

  // time is in minutes
  constructor(time = 30){
    this.time = time * 1000 * 60; // in milliseconds
    this.listeners = new Map();
  }

  on(label, callback) {
    this.listeners.has(label) || this.listeners.set(label, []);
    this.listeners.get(label).push(callback);
  }

  emit(label, ...args) {  
    let listeners = this.listeners.get(label);
    if (listeners && listeners.length) {
        listeners.forEach((listener) => {
            listener(...args); 
        });
        return true;
    }
    return false;
  }

  startTimer(){

    if(this.timer){
      this.stopTimer();
    }

    this.emit('start');
    this.timer = setTimeout(() => {
      this.emit('end');
    }, this.time);
  }

  stopTimer(){
    this.emit('clear');
    clearTimeout(this.timer);
  }
}

export default Timer;




// WEBPACK FOOTER //
// ./src/Timer.js